import CellWithInfo from "./CellWithInfo";

export default CellWithInfo;
